import {createSvgIcon} from '../create-svg-icon';

export const SyncAltIcon = createSvgIcon(
  <path d="M7.41 13.41 6 12l-4 4 4 4 1.41-1.41L5.83 17H21v-2H5.83zm9.18-2.82L18 12l4-4-4-4-1.41 1.41L18.17 7H3v2h15.17z" />
, 'SyncAltOutlined');
